export const overlayColors =
[
    '#500000',
    '#000000',
    '#FFFFFF'
]